import { memo, useState, useCallback } from 'react'
import Month from 'components/common/Month'
import { useTranslation } from 'services/Translation'
import Header from './Header'

interface CalendarCardProps {
  field: {
    value: Date | null
    onChange: (date: Date) => void
  }
  events: any
  appointmentDuration?: number
  disableBefore: Date
  selectedDates?: Date[]
  isRangeSelection?: boolean
}

const CalendarCard = ({
  field: { value, onChange },
  events,
  appointmentDuration,
  disableBefore,
  selectedDates = [],
  isRangeSelection = false,
}: CalendarCardProps) => {
  const { formatDate: format } = useTranslation()
  const currDate = new Date()
  const [monthView, setMonthView] = useState({
    month: value?.getMonth() || currDate.getMonth(),
    year: value?.getFullYear() || currDate.getFullYear(),
  })
  const handleDateChange = useCallback(
    (newDate: Date) => {
      onChange(newDate)
    },
    [onChange]
  )
  const handleNavClick = useCallback(
    (direction: number) => {
      const newMonth = monthView.month + direction
      setMonthView({
        month: newMonth === 12 ? 0 : newMonth === -1 ? 11 : newMonth,
        year:
          newMonth === 12
            ? monthView.year + 1
            : newMonth === -1
            ? monthView.year - 1
            : monthView.year,
      })
    },
    [monthView]
  )

  return (
    <div style={{ width: '100%', maxWidth: '40rem', height: '20rem', transform: 'scale(0.85)', transformOrigin: 'top left' }} className="px-4">
      <Header
        onNavClick={handleNavClick}
        currentMonth={format(new Date(monthView.year, monthView.month), 'MMMM yyyy')}
      />
      <div className="flex justify-start">
        <Month
          className="pt-8"
          currDate={currDate}
          monthView={monthView}
          events={events}
          selectedDate={value}
          selectedDates={selectedDates}
          isRangeSelection={isRangeSelection}
          small={false}
          mini={false}
          appointmentDuration={appointmentDuration}
          onDateChange={handleDateChange}
          disableBefore={disableBefore}
          calendarType={undefined}
        />
      </div>
    </div>
  )
}

CalendarCard.defaultProps = {
  appointmentDuration: 0,
  selectedDates: [],
  isRangeSelection: false,
}

CalendarCard.whyDidYouRender = true

export default memo(CalendarCard)
